var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgBilling = function SvgBilling(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44 42.8H24.53c-2.41 0-6.88.75-7.87-2.21-.32-.96-.12-2.2-.12-3.19V25.71c0-1.49-.12-2.79 1.28-3.8 1.05-.76 2.19-.71 3.4-.71H42.7c1.07 0 2.12-.08 3.11.45 1.64.88 1.69 2.25 1.69 3.83v11.64c0 .94.09 1.94 0 2.89-.17 1.73-1.87 2.73-3.47 2.8-.76.03-.73 2.43 0 2.4 2.89-.12 4.48-2.56 4.53-5.26.03-1.32 0-2.65 0-3.97 0-3.88.04-7.77 0-11.65-.02-2.21-.87-4.48-3.13-5.27-1-.35-2.13-.25-3.17-.25H29.92c-3.24 0-6.48-.05-9.72 0-2.4.03-4.18 1.72-4.59 4.06-.21 1.21-.1 2.52-.1 3.74v12.36c0 1.78.12 3.55 1.44 4.91 1.12 1.16 2.51 1.34 4.02 1.34h23.08c.74 0 .75-2.4 0-2.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 27.2h32c.74 0 .75-2.4 0-2.4H16c-.74 0-.75 2.4 0 2.4Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBilling);
export default ForwardRef;